import store from '../../store'

export default () => {
  const user = store.getState().v1user
  if (!user) return false

  return user.hasCustomTourOperatorOverwrite
}
